import { GetStaticPaths, GetStaticProps } from "next"
import ProductDetails from "@views/ProductDetails"
import { getAllProducts, getProduct } from "@views/ProductDetails/queries"
import { getClient } from "@utils/sanity"

export default ProductDetails

export const getStaticPaths: GetStaticPaths = async () => {
  const products = await getClient().fetch(getAllProducts)
  const routes = products.map((product) => ({
    params: { slug: product.slug.current },
  }))

  return {
    paths: routes || null,
    fallback: false,
  }
}

export const getStaticProps: GetStaticProps = async ({
  params = {},
  preview = false,
}) => {
  const { slug } = params
  const pageData = await getClient(preview).fetch(getProduct, {
    slug,
  })

  if (
    pageData &&
    pageData.product &&
    (!pageData.product._id || pageData.product.productStatus === "Discontinued")
  ) {
    return {
      notFound: true,
    }
  }

  return {
    props: { preview, pageData, slug },
  }
}
